module.exports = __webpack_public_path__ + "img/bs_plus_shop_soon_de-AT-old.cfc785a3.jpg";